export default __webpack_public_path__ + "static/media/email-configmed@1x.81094deb.png";